module.exports = __webpack_public_path__ + "img/result_wine_h.5a446a7a.png";